<script setup lang="ts">
const props = defineProps<{
  url: string
}>()

const clicked = ref(false)
</script>

<template>
  <VideoPreviewThumbnail v-if="!clicked" :url="props.url" class="aspect-video group" @click="clicked = true">
    <VideoPreviewPlayIcon />
  </VideoPreviewThumbnail>
  <VideoPreviewPlayer v-else :url="props.url" />
</template>
